import { Dayjs } from 'dayjs';
import type { IssueAssignmentFormValues } from 'app/pages/IssuesPage/components/IssueAssignmentFields';

/** Fields supported by inspection PUT routes (room/asset issue update). */
export function buildIssueAssignmentPutFields(
  assignmentValues: IssueAssignmentFormValues
): Record<string, string | number> {
  const out: Record<string, string | number> = {};

  if (assignmentValues.assignedToUserId) {
    out.assignedToUserId = Number(assignmentValues.assignedToUserId);
  }

  if (assignmentValues.dueDate) {
    out.dueDate = (assignmentValues.dueDate as Dayjs).toISOString();
  }

  if (assignmentValues.criticalityKey !== undefined) {
    out.criticalityKey = assignmentValues.criticalityKey;
  }

  if (assignmentValues.status) {
    out.status = assignmentValues.status;
  }

  return out;
}
